import React from 'react';
import { Provider } from 'react-redux'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.css';
// Bootstraps JavaScript wird nicht mehr gebraucht: die Dialoge kommen von reactstrap,
// das Kopfmenue steuert EIVHeader selbst. Damit entfallen auch jQuery und popper.js.
import { thunk } from 'redux-thunk'
import { createLogger } from 'redux-logger'
import throttle from 'lodash/throttle';
import {saveState, loadState} from "./localStorage";
import './eiv.css';
import './theme-dark.css';
import './print.css';
import './i18n';
import { applyDisplayMode } from './displayMode';

import { createStore,  applyMiddleware } from 'redux'
import rootReducer from './store/reducers'
import { getIntendedVNR, applyVNR } from './prestartPreparation';
import * as ReactDOMClient from 'react-dom/client';

const persistedState = loadState();
// Vor dem ersten Rendern: sonst blitzt die Seite im Dunkelmodus hell auf.
applyDisplayMode(persistedState && persistedState.appNavigation
	? persistedState.appNavigation.displayMode : undefined);

const loggerMiddleware = createLogger();
const store = createStore(rootReducer, persistedState, applyMiddleware(
	thunk, // lets us dispatch() functions
	loggerMiddleware // neat middleware that logs actions
));

const intendedVNR = getIntendedVNR();
if(intendedVNR){ 
	applyVNR(store, intendedVNR);
}

const renderReactDom = () => {
	const container = document.getElementById('root');
	const root = ReactDOMClient.createRoot(container);
	root.render(
	<Provider store={store}>
			<App state = {store.getState()}/>
	</Provider>);
}

renderReactDom();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

store.subscribe(throttle(() => { 
	const state = store.getState()
	if(state.appNavigation.saveStateToLocalStorage) saveState(state);
}, 1000));

